// Client-side access gate for the shared prototype.
const ACCESS_EMAIL = 'marketing@vexu.ai'
const ACCESS_PASSWORD = 'VeXu@202600'
const SESSION_KEY = 'vexu-prototype-access'

export function verifyAccess(email: string, password: string): boolean {
  return email.trim().toLowerCase() === ACCESS_EMAIL && password === ACCESS_PASSWORD
}

export function hasAccessSession(): boolean {
  if (typeof window === 'undefined') return false
  // Screens previews render individual states and skip the gate.
  if (new URLSearchParams(window.location.search).has('mp_screen')) return true
  try {
    return window.sessionStorage.getItem(SESSION_KEY) === 'granted'
  } catch {
    return false
  }
}

export function grantAccessSession(remember: boolean) {
  try {
    window.sessionStorage.setItem(SESSION_KEY, 'granted')
    if (remember) window.localStorage.setItem(SESSION_KEY, 'granted')
  } catch {
    // Storage unavailable — access lasts for this page view only.
  }
}

export function hasRememberedAccess(): boolean {
  try {
    return window.localStorage.getItem(SESSION_KEY) === 'granted'
  } catch {
    return false
  }
}
